"use client";
import React, { useState, useRef, useEffect, useMemo, useCallback } from "react";
import { Link, useLocation } from "react-router-dom";
// import Image from "next/image";
import { Sidebar } from "primereact/sidebar";
import { Dropdown } from "primereact/dropdown";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { FileUpload } from "primereact/fileupload";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import downvector from '../../../assets/images/DownVector.svg';
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import TopLinesChart from "../charts/toplineschart";
import { color } from "echarts";
import { Button } from "antd";
import { fetchPop_Up_Absenteeism, fetchPop_Up_Reasons, fetchTop_tile_school_popup } from "../../../redux/slices/staffdetails";
import { useDispatch, useSelector } from "react-redux";
import LoaderContainer from "../../../components/LoaderContainer/LoaderContainer";
import { xlsxExport } from "../../../components/chartwrapper/excelDownload";
import { Calendar } from "primereact/calendar";
import { InputText } from "primereact/inputtext";

export default function StaffBottomBar1(props) {
    const { visible, onHide, setActiveIndexList, title } = props;

    const [visibleDetailTable, setVisibleDetailTable] = useState(false);
    const [selectedSchool, setSelectedSchool] = useState(null);
    const [selectedReason, setSelectedReason] = useState(null);
    const [date, setDate] = useState(props?.date);    
    
    /* Redux State */
    const dispatch = useDispatch();

    // Staff Wise
    const Pop_Up_Reasons = useSelector(state => state.staffdetails.Pop_Up_Reasons);
    const Pop_Up_ReasonsLoading = useSelector(state => state.staffdetails.Pop_Up_Reasonsloading);
    const Pop_Up_Absenteeism = useSelector(state => state.staffdetails.Pop_Up_Absenteeism);
    const Pop_Up_AbsenteeismLoading = useSelector(state => state.staffdetails.Pop_Up_Absenteeismloading);

    // School Wise
    const Top_tile_school_popup = useSelector(state => state.staffdetails.Top_tile_school_popup);
    const Top_tile_school_popupLoading = useSelector(state => state.staffdetails.Top_tile_school_popuploading);

    // Filters
    const appliedfilter = useSelector(state => state.filter.appliedFilters);
    /* */
    
    useEffect(()=> {
        setDate(props?.date);
    },[visible])

    /* API Call */
    useEffect(() => {
        if (visible) {
            dispatch(fetchTop_tile_school_popup({
                "elasticQueryName": "Top_tile_school_popup",
                "filters": appliedfilter,
                "dynamicColumns": [{ columnName: "#{date}", columnValue: date.toLocaleDateString('en-US'), "excludeKeyword": false }],
            }));
        }
    },[visible, appliedfilter, date])

    useEffect(() => {
        if (visibleDetailTable) {
            dispatch(fetchPop_Up_Reasons({
                "elasticQueryName": "Pop_Up_Reasons",
                "filters": [title == 'Schools With High Absentees' ? { "columnName": "SCHOOL_OFFICIAL_NAME", "columnValue": selectedSchool, "excludeKeyword": false } : { "columnName": "MEASURE_TYPE", "columnValue": selectedReason, "excludeKeyword": false }].concat(appliedfilter?.filter(itr => itr?.columnName == 'SCHOOL_YEAR')),
                "dynamicColumns": [{ columnName: "#{date}", columnValue: date.toLocaleDateString('en-US'), "excludeKeyword": false }],
            }));
        }
    }, [visibleDetailTable, selectedSchool, selectedReason])
    /* */

    const handleSchoolClick = (rowData) => {
        setSelectedSchool(rowData?.SCHOOL_OFFICIAL_NAME);
        setVisibleDetailTable(true);
    };

    const handleReasonClick = (rowData) => {
        setSelectedReason(rowData?.ABSENCE_REASON);
        setVisibleDetailTable(true);
    };

    const schoolNameTemplate = (rowData) => (
        <span
            style={{ cursor: 'pointer' }}
            onClick={() => handleSchoolClick(rowData)}
        >
            <u>{rowData.SCHOOL_OFFICIAL_NAME}</u>
        </span>
    );

    const AbsenceReasonTemplate = (rowData) => (
        <span
            style={{ cursor: 'pointer' }}
            onClick={() => handleReasonClick(rowData)}
        >
            <u>{rowData.ABSENCE_REASON}</u>
        </span>
    );

    /* Date Restricted Logic */
    const thisweek_dates = useMemo(() => {
        const today = new Date();
        const firstday_of_week = new Date(today.setDate(today.getDate() - today.getDay())); // Sunday

        return Array.from({ length: 5 }, _ => new Date(firstday_of_week.setDate(firstday_of_week.getDate() + 1))).filter(date => date <= new Date());
    }, [])
    /* */

    const TableFilterTemplate = (options) => {
        return (
            <div className="relative flex items-center">
                <i className="pi pi-search absolute left-3 text-gray-500 text-sm"></i>
                <InputText
                    value={options.value}
                    onChange={(e) => options.filterCallback(e.target.value)}
                    placeholder="Search here"
                    className="pl-10 pr-3 py-1.5 border border-blue-300 rounded-md w-full text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
                />
            </div>
        );
    };

    const ProcessedTableData = useCallback((data, column) => {
        const obj = {};
        data?.forEach((item) => {
            const { [column]: col, ...rest } = item;
            if (!obj[col]) {
                obj[col] = { ...item };
            } else {
                obj[col].METRIC_NUMERATOR += item?.METRIC_NUMERATOR
            }
        })

        return Object.values(obj)
    },[date])
    return (
        <>
            <Sidebar
                visible={visible}
                onHide={onHide}
                position="bottom"
                className="bottomBar w-full bg-[#15181F]"
                blockScroll={true}
            >
                <div className="px-[30px] py-[15px] pb-0">
                    <div className="mb-[15px] flex justify-between">
                        <div className="text-[20px] text-[#fff] pl-[130px] pt-[10px] ">{title}</div>
                        <div className="flex gap-10">
                            <Calendar
                                value={date}
                                onChange={e => setDate(e.value)}
                                placeholder="Select a date"
                                // showButtonBar
                                disabledDays={[0,6]} // restrict Weekend
                                // enabledDates={thisweek_dates}
                                showIcon
                                dateFormat="m/d/yy"
                                className="bg-[#1b2a37] text-[#fff] rounded-md shadow"
                                inputClassName="w-full px-3 py-2 text-sm shadow-none text-white bg-[#1b2a37]"
                                panelClassName="custCalendar"
                            />
                            <button onClick={()=>xlsxExport({filename: "Schools With High Absentees - (SchoolWise)", data : Top_tile_school_popup})} className="bg-[#2E265A] text-[16px] leading-[16px] text-[#fff] rounded-full px-4 py-4 shadow ">Export XLS</button>
                        </div>
                    </div>
                    <div className="bg-[#1a2025cc]">
                        <div className="text-[16px] text-[#fff] leading-[24px] px-4 py-2 ">Detailed View of - {title}</div>
                        <div className="">
                            <LoaderContainer loading={Top_tile_school_popupLoading} height={'25rem'} width={'100%'}>
                            <DataTable
                                value={title == 'Major Absence Reason' ? ProcessedTableData(Top_tile_school_popup, 'ABSENCE_REASON') : ProcessedTableData(Top_tile_school_popup, 'SCHOOL_OFFICIAL_NAME')}
                                className="staffTable"
                                scrollable
                                scrollHeight="24.5rem"
                                paginator // Paginator Enable
                                rows={10} // Number of rows per page
                                rowsPerPageOptions={[10, 20, 30]} // Options in Paginator Dropdown
                                style={{ width: "100%" }}
                                emptyMessage={
                                    <div className="flex justify-center">
                                        No Data Available.
                                    </div>
                                }
                                >
                                {title == 'Schools With High Absentees' && <Column
                                    field="SCHOOL_YEAR"
                                    header="School Year"
                                    sortable
                                    filter
                                    showFilterMenuOptions={false}
                                    filterElement={TableFilterTemplate}
                                    filterMenuClassName="custfilter"
                                // style={{ maxWidth: "4rem" }}
                                ></Column>}
                                {/* {title == 'Schools With High Absentees' && <Column
                                    field="SCHOOL_ID"
                                    header="School ID"
                                    sortable
                                    filter
                                    showFilterMenuOptions={false}
                                    filterElement={TableFilterTemplate}
                                    filterMenuClassName="custfilter"
                                // style={{ maxWidth: "4rem" }}
                                ></Column>} */}
                                {title == 'Schools With High Absentees' && <Column
                                    field="SCHOOL_OFFICIAL_NAME"
                                    header="Location Name"
                                    sortable
                                    filter
                                    showFilterMenuOptions={false}
                                    filterElement={TableFilterTemplate}
                                    filterMenuClassName="custfilter"
                                    // style={{ minWidth: "8rem" }}
                                    body={schoolNameTemplate}
                                ></Column>}
                                {title == 'Major Absence Reason' && <Column
                                    field="ABSENCE_REASON"
                                    header="Absences Reason"
                                    // style={{ minWidth: "8rem" }}
                                    sortable
                                    filter
                                    showFilterMenuOptions={false}
                                    filterElement={TableFilterTemplate}
                                    filterMenuClassName="custfilter"
                                    body={AbsenceReasonTemplate}
                                ></Column>}
                                <Column
                                    field="INCIDENT_TIME"
                                    header="Absent Date"
                                    sortable
                                    filter
                                    showFilterMenuOptions={false}
                                    filterElement={TableFilterTemplate}
                                    filterMenuClassName="custfilter"
                                // style={{ minWidth: "8rem" }}
                                ></Column>
                                <Column
                                    field="METRIC_NUMERATOR"
                                    header="# of Absences"
                                    sortable
                                    filter
                                    showFilterMenuOptions={false}
                                    filterElement={TableFilterTemplate}
                                    filterMenuClassName="custfilter"
                                // style={{ minWidth: "8rem" }}
                                ></Column>
                            </DataTable>
                            </LoaderContainer>
                        </div>
                    </div>
                </div>
            </Sidebar>
            <Sidebar visible={visibleDetailTable} onHide={() => setVisibleDetailTable(false)} 
                position="bottom"
                className="bottomBar w-full bg-[#15181F]"
                blockScroll={true}
            >
                <div className="px-[30px] py-[15px] pb-0">
                    <div className="mb-[15px] flex justify-between">
                        <div className="text-[20px] text-[#fff] pl-[130px] pt-[10px] ">{title}</div>
                        <button onClick={()=>xlsxExport({filename: "Schools With High Absentees - (StaffWise)", data : Pop_Up_Reasons})} className="bg-[#2E265A] text-[16px] leading-[16px] text-[#fff] rounded-full px-4 py-4 shadow ">Export XLS</button>
                    </div>
                    <div className="bg-[#1a2025cc]">
                        <div className="text-[16px] text-[#fff] leading-[24px] px-4 py-2 ">Detailed View of - {title}</div>
                        <div className="">
                        <LoaderContainer loading={Pop_Up_ReasonsLoading} height={'25rem'} width={'100%'}>
                            <DataTable
                                value={Pop_Up_Reasons}
                                className="staffTable"
                                scrollable
                                scrollHeight="24.5rem"
                                paginator // Paginator Enable
                                rows={10} // Number of rows per page
                                rowsPerPageOptions={[10, 15, 25]} // Options in Paginator Dropdown
                                style={{ width: "100%" }}
                                >
                                <Column
                                    field="STAFF_ID"
                                    header="Staff ID"
                                    // style={{ maxWidth: "4rem" }}
                                    sortable
                                    filter
                                    showFilterMenuOptions={false}
                                    filterElement={TableFilterTemplate}
                                    filterMenuClassName="custfilter"
                                ></Column>
                                <Column
                                    field="STAFF_NAME"
                                    header="First Name"
                                    // style={{ minWidth: "8rem" }}
                                    sortable
                                    filter
                                    showFilterMenuOptions={false}
                                    filterElement={TableFilterTemplate}
                                    filterMenuClassName="custfilter"
                                ></Column>
                                <Column
                                    field="LAST_NAME"
                                    header="Last Name"
                                    // style={{ minWidth: "8rem" }}
                                    sortable
                                    filter
                                    showFilterMenuOptions={false}
                                    filterElement={TableFilterTemplate}
                                    filterMenuClassName="custfilter"
                                ></Column>
                                <Column
                                    field="ROLE"
                                    header="Role"
                                    // style={{ minWidth: "8rem" }}
                                    sortable
                                    filter
                                    showFilterMenuOptions={false}
                                    filterElement={TableFilterTemplate}
                                    filterMenuClassName="custfilter"
                                ></Column>
                                <Column
                                    field="LOCATION"
                                    header="Location"
                                    // style={{ minWidth: "8rem" }}
                                    sortable
                                    filter
                                    className="whitespace-nowrap"
                                    showFilterMenuOptions={false}
                                    filterElement={TableFilterTemplate}
                                    filterMenuClassName="custfilter"
                                ></Column>
                                <Column
                                    field="GENDER"
                                    header="Gender"
                                    // style={{ minWidth: "8rem" }}
                                    sortable
                                    filter
                                    showFilterMenuOptions={false}
                                    filterElement={TableFilterTemplate}
                                    filterMenuClassName="custfilter"
                                ></Column>
                                <Column
                                    field="ETHNICITY"
                                    header="Ethnicity"
                                    // style={{ minWidth: "8rem" }}
                                    sortable
                                    filter
                                    showFilterMenuOptions={false}
                                    filterElement={TableFilterTemplate}
                                    filterMenuClassName="custfilter"
                                ></Column>
                                <Column
                                    field="ABSENTEES"
                                    header="Absences"
                                    // style={{ minWidth: "8rem" }}
                                    sortable
                                    filter
                                    showFilterMenuOptions={false}
                                    filterElement={TableFilterTemplate}
                                    filterMenuClassName="custfilter"
                                ></Column>
                                {title=='Schools With High Absentees' && <Column
                                    field="ABSENCE_REASON"
                                    header="Absences Reason"
                                    // style={{ minWidth: "8rem" }}
                                    sortable
                                    filter
                                    showFilterMenuOptions={false}
                                    filterElement={TableFilterTemplate}
                                    filterMenuClassName="custfilter"
                                ></Column>}
                                <Column
                                    field="NO_OF_DAYS"
                                    header="# of Days Absence (As of Today)"
                                // style={{ minWidth: "8rem" }}
                                    sortable
                                    filter
                                    showFilterMenuOptions={false}
                                    filterElement={TableFilterTemplate}
                                    filterMenuClassName="custfilter"
                                    className="hltcolor"
                                ></Column>
                                <Column
                                    field="PERCENTAGE"
                                    header="% of Days Absence (As of Today)"
                                // style={{ minWidth: "8rem" }}
                                    body={(rowData) => `${rowData.PERCENTAGE?.toFixed(2)}%`} 
                                    sortable
                                    filter
                                    showFilterMenuOptions={false}
                                    filterElement={TableFilterTemplate}
                                    filterMenuClassName="custfilter"
                                    className="hltcolor"
                                ></Column>
                            </DataTable>
                        </LoaderContainer>
                        </div>
                    </div>
                </div>
            </Sidebar>
        </>
    )
}